'use client';

import React from 'react';

import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';
import { ContentLayout } from '@/features/client/Services/components/ContentLayout/ContentLayout';
import { RequestForm } from '@/features/client/Forms/RequestForm/RequestForm';
import { ServicesNavMenu } from '@/features/client/Services/components/ServicesNavMenu/ServicesNavMenu';
import image from '@/public/images/services/main_page/air_conditiong.webp';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContentV2 } from '@/features/client/Services/components/Content/ContentV2';

import certified from '@/public/images/services/heating/certified.png';
import clear from '@/public/images/services/air_conditioning/clear.png';
import pricing from '@/public/images/services/heating/pricing.png';
import garanty from '@/public/images/services/heating/garanty.png';
import customerService from '@/public/images/services/ac_installation/customer-service.png';
import time from '@/public/images/services/ac_installation/time.png';
import chooseImage from '@/public/images/services/ac_installation/choose.jpg';
import chooseImage2 from '@/public/images/services/heating-installation/chooseImage.jpg';
import installationImage from '@/public/images/services/ac_installation/installation-process.jpg';
import installationImage2 from '@/public/images/services/heating-installation/installation-proccess.jpg';
import air from '@/public/images/services/air_conditioning/air.png';
import energy from '@/public/images/services/air_conditioning/energy.png';
import control from '@/public/images/services/air_conditioning/control.png';
import heating from '@/public/images/services/heating/heating.png';
import stayAtHome from '@/public/images/services/ac_installation/stay-at-home.png';
import local from '@/public/images/services/heating/local.png';

const data = {
  title: 'Our HVAC Services in San Diego, CA',
  description: `With over 20 years of experience, we stand on guard of your indoor comfort by offering comprehensive air conditioning and heating repairs in San Diego.`,
  image: image,
  offer_title: '',
  offer_data: [
    {
      title: 'Air Conditioning Services',
      description:
        'We specialize in installing and repairing air conditioning systems, including central air, ductless AC units, and ductless mini split systems. Whether you’re looking for reliable <a href="https://tytum.com/services/heating-and-air/air-conditioning">air conditioning service in San Diego</a> or want to upgrade to an energy-efficient <a href="https://tytum.com/services/heating-and-air/ductless-ac-installation">mini split AC in San Diego</a>, our experts ensure seamless integration and customized comfort solutions for your home or business.',
      list: [],
    },
    {
      title: 'Heating Services',
      description:
        'Whether you require a furnace, a heat pump, or professional <a href="https://tytum.com/services/heating-and-air/heating">heating repair service in San Diego</a>, we are adept at promptly diagnosing and resolving heating system issues to ensure reliable warmth during colder months.',
      list: [],
    },
    {
      title: 'Indoor Air Quality Services',
      description:
        'We can enhance your HVAC system with purifying and humidifying equipment to make your indoor space a safer and cleaner environment.',
      list: [],
    },
    {
      title: 'Thermostat Repair and Upgrades',
      description:
        'If your thermostat malfunctions, we’ll help you maintain full control of your indoor climate by replacing it or upgrading to a smart programmable thermostat for maximum energy efficiency.',
      list: [],
    },
    {
      title: 'Seasonal HVAC Maintenance Plans',
      description:
        'Our seasonal packages on HVAC maintenance in San Diego include spring AC tune-ups and fall heating system check-ups, ensuring your HVAC systems are prepared for the changing seasons. And if your equipment is outdated, we also provide professional <a href="https://tytum.com/services/heating-and-air/heating-installation">heating installation in San Diego</a> to give your home reliable warmth all winter long.',
      list: [],
    },
    {
      title: 'Energy Efficiency Consulting',
      description:
        'We conduct home energy audits and provide recommendations for HVAC system efficiency upgrades to help you save on energy bills without sacrificing comfort.',
      list: [],
    },
  ],
  banner_title: `“Year-Round Comfort Solutions”`,
  banner_description:
    'Stay comfortable all year with Tytum’s HVAC services in San Diego. If you need furnace repair, air conditioning service, or want to upgrade your heating and cooling system, you’ve come to the right place.',
  banner_with_button: true,
  why_title: '',
  why_description: '',
  why_items: [],
  why_footerText: '',
  extraContent: [
    {
      title: 'Why Choose Tytum for Heating and Air Conditioning Solutions?',
      image: chooseImage,
      description:
        "Knowing the importance of addressing HVAC problems quickly and efficiently, we deliver quality results on time and within budget, ensuring your home's safety and functionality.",
      items: [
        {
          title: 'Proven HVAC Expertise',
          image: clear,
          description:
            "Our skilled team is trained to handle all major equipment brands and models, ensuring efficient, long-lasting solutions that maximize your HVAC system’s performance, no matter the problem's scope and complexity.",
        },
        {
          title: 'Certified Technicians',
          image: certified,
          description:
            'We employ only pros distinguished by a strong expertise in their fields. To catch up with the latest industry advancements and come up with innovative solutions, they are continuously trained.',
        },
        {
          title: 'Emergency & Same-Day HVAC Service',
          image: time,
          description:
            'Prioritizing speed and efficiency in every service call, we also offer 24/7 emergency service for heating and air conditioning in San Diego, providing fast and reliable assistance whenever you need it.',
        },
        {
          title: 'Transparent Pricing',
          image: pricing,
          description:
            'We strive to make our services affordable and accessible to every customer by offering competitive pricing and transparent quotes, with no surprise costs or hidden charges added along the way.',
        },
        {
          title: '100% Satisfaction Guarantee',
          image: garanty,
          description:
            'We guarantee top-level workmanship, quality service, and lasting results. If you feel that we underperform in some aspect, we will make it right, no questions asked.',
        },
        {
          title: 'Community Commitment',
          image: customerService,
          description:
            'Providing professional HVAC services in San Diego, CA, we care about our community by making a positive impact through personalized service. Known as <a href="https://tytum.com/services/electrical">Tytum Electric in San Diego</a>, our team combines HVAC expertise with trusted electrical solutions for complete home comfort.',
        },
      ],
      footerText: '',
    },
    {
      title: 'HVAC Systems We Service in San Diego',
      image: chooseImage2,
      description:
        'When it comes to HVAC in San Diego, we service all types of residential and commercial HVAC systems, bringing dependable indoor comfort to homes and businesses in the area. Backed by extended local expertise, our certified techs know the unique peculiarities of the climate in Southern California and deliver system-specific HVAC solutions that will smoothly perform for years to come.',
      items: [
        {
          title: 'Central HVAC Systems',
          image: energy,
          description:
            'These systems are built to deliver consistent heating and cooling through a network of ducts connected to a central unit. Ideal for maintaining uniform temperatures across entire homes or large spaces, they are the most common HVAC solutions in San Diego.<br /><br />Subject to proper installation and servicing, central systems operate quietly and maintain highly efficient air circulation for reliable whole-home comfort. At Tytum, we know how to optimize these systems for peak performance and keep them running like a charm across the seasons.',
        },
        {
          title: 'Ductless Mini-Split Systems',
          image: stayAtHome,
          description:
            'Offering flexible cooling and heating without the need for ductwork, mini-splits deliver zoned comfort where you need it. Distinguished by high-energy efficiency and ease of installation, these systems are yet another popular HVAC option favored by San Diego residents for older homes without duct systems, home additions and converted garages, apartments, and multi-zone living spaces.',
        },
        {
          title: 'Heat Pumps',
          image: control,
          description:
            'Using a single system, heat pumps are energy-wise solutions for both heating and cooling your property. They transfer heat rather than generate it, which makes these units a smart choice for the mild climate of San Diego. With proper care, heat pumps minimize energy waste, reduce your energy bills, and provide minimal environmental impact.',
        },
        {
          title: 'Furnaces',
          image: heating,
          description:
            'Furnaces are still an important component of many HVAC systems, ensuring reliable heat during colder months. However, maintaining efficient furnace operation is critical not only for your home’s comfort but also for its safety.<br /><br />At Tytum, we provide seasonal maintenance, repairs, and safety inspections to keep furnace systems running at their best. Early service will prevent serious breakdowns and safety hazards, so don’t hesitate to contact us if you notice:<br /><br />• Unusual noise or vibrations<br />• Uneven heating or cold spots<br />• Frequent cycling on and off<br />• Burning smell during operation',
        },
        {
          title: 'Air-Conditioning Units',
          image: air,
          description:
            'A part of HVAC systems, well-maintained AC units ensure consistent comfort even during peak summer heat while extending system lifespan and lowering operational costs. From refrigerant issues to airflow problems, our techs diagnose and eliminate AC problems fast and quickly restore cooling performance.',
        },
        {
          title: 'Commercial HVAC Systems',
          image: local,
          description:
            'With a full spectrum of expert HVAC installation, repair, and maintenance services for homes, we offer the same for commercial properties in San Diego, including:<br /><br />• Office buildings<br />• Retail stores<br />• Restaurants and hospitality venues<br />• Property management companies<br />• Multi-unit commercial facilities<br /><br />We focus on system uptime, preventative maintenance, and rapid repair response to minimize disruptions, protect daily operations, and maintain comfortable spaces.',
        },
      ],
      footerText: '',
    },
    {
      title: 'Signs You Need HVAC Repair',
      image: installationImage,
      description:
        'Recognizing early signs that your HVAC system is failing can help prevent costly repairs, sudden breakdowns, and inefficiencies. Here are key indicators that your equipment for heating and cooling in San Diego requires professional treatment.',
      items: [
        {
          title: '1. Unusual Noises',
          description:
            'Your HVAC system should operate relatively quietly. If you start hearing strange noises, such as banging, clanking, squealing, screeching, hissing, rattling, or clicking, it’s the first alarm about the broken compressor or blower parts, worn-out belts, thermostat or capacitor malfunctions, and even ductwork issues.',
        },
        {
          title: '2. Uneven Heating or Cooling',
          description:
            'Do you notice some rooms are too hot while others remain too cold? If adjusting your thermostat doesn’t fix the issue, it’s a sign of leaky or blocked ductwork or a failed thermostat that calls for professional inspection.',
        },
        {
          title: '3. Frequent or Short Cycling',
          description:
            'If your system frequently turns on and off too quickly, it may result from a faulty thermostat, overheating, or ignition system problems for a furnace, and from a low refrigerant level or dirty evaporator for an air conditioner.',
        },
        {
          title: '4. Rising Energy Bills Without Explanation',
          description:
            'If your utility bills suddenly spike without any changes in usage, your HVAC system may be losing efficiency due to a failing compressor, refrigerant leaks, dirty coils, or leaky ductwork. To restore efficiency and reduce energy costs, professional help is required.',
        },
        {
          title: '5. Unpleasant Odors',
          description:
            'Any unusual smell coming from your HVAC system is a sign of a serious problem, such as wiring or motor issues, dust buildup, mold growth, or gas leaks. If that’s the case, you need to contact a company for expert HVAC service in San Diego, CA.',
        },
        {
          title: '6. Water Leaks',
          description:
            'Neither your air conditioner nor furnace should leak water. Dripping and moisture in any part of the system can signal a blocked condensate drain line, frost on the evaporator coil, or drain pan damage. Neglecting this problem can cause mold growth and more serious system faults.',
        },
        {
          title: '7. System Fails to Reach the Desired Temperature',
          description:
            'If your thermostat is set to a comfortable temperature but the system isn’t cooling or heating effectively, it might be a faulty thermostat, a failing heating element or gas burner, or refrigerant issues.',
        },
        {
          title: '8. Poor Indoor Air Quality',
          description:
            'If you experience more dust buildup, worsened allergies, or dry air, your system may be struggling with a clogged air filter, dirty ductwork, or inefficient humidity control.',
        },
      ],
      footerText: '',
    },
    {
      title: 'Our HVAC Service Process',
      image: installationImage2,
      description:
        'HVAC repair in San Diego could be stressful unless you contact Tytum. We stick to a simple yet efficient algorithm to minimize frustration for a client and get your HVAC system back to a serviceable condition as soon as possible.',
      items: [
        {
          title: 'Scheduling an Appointment',
          description:
            'Booking our service is as easy as filling out an online form or giving us a call to talk to our friendly customer support team directly. You can order same-day emergency service or plan a visit to match your schedule.',
        },
        {
          title: 'Diagnosis and Quote',
          description:
            'One of our expert techs will arrive as agreed, fully equipped and ready to assess the issue. They will thoroughly examine your HVAC system to pinpoint the problem and provide a detailed, transparent estimate without pushing unnecessary repairs.',
        },
        {
          title: 'Fast and Reliable HVAC Repair or Installation',
          description:
            'Once you approve the estimate, our team gets straight to work. They carry high-quality replacement parts and tools, allowing us to complete most repairs on the spot. Our technicians work quickly, ensuring you receive a lasting repair that keeps your system running smoothly. If you need a brand-new HVAC installation in San Diego, we’ll have you set up as well, using premium equipment and sticking to high industry standards.',
        },
        {
          title: 'Final Check and Customer Approval',
          description:
            'Your satisfaction is our priority, so before we consider the job complete, we perform a final system check and walk you through the repairs, answering your questions and providing helpful maintenance tips.',
        },
      ],
      footerText: '',
      banner: {
        title: 'Book an HVAC Service in San Diego Today',
        description:
          'When your HVAC system breaks down, you want to eliminate the problem and restore comfort to your home or business within the shortest time possible. We offer swift and budget-friendly HVAC service in San Diego, as well as <a href="https://tytum.com/services/heating-and-air/ac-installation">AC installation in San Diego</a>, with a focus on quality and results that will last. Don’t let a faulty AC or heater hold you back. Trust our professionals to keep your indoor atmosphere comfortable year-round. We’re just a call away.',
        bookServiceButton: true,
      },
    },
    {
      title: 'Frequently Asked Questions (FAQ)',
      description: '',
      items: [
        {
          title: '✓ How long does HVAC repair take?',
          description:
            'The repair time will depend on the complexity of the issue and the scope of work required. It might take from an hour to a full day. For the most accurate time estimate, our technicians will diagnose the problem first and provide a clear timeline before starting the repair.',
        },
        {
          title: '✓ Do you offer same-day service?',
          description:
            'We understand that HVAC issues can’t wait. So, we provide both same-day and emergency repair services for HVAC in San Diego, California. In case of HVAC issues, give us a quick call, and our tech will arrive at your location ASAP.',
        },
        {
          title: '✓ How many years should an HVAC system last?',
          description:
            'The average lifespan of an HVAC system is about 15 years. Planned maintenance and timely repairs will help you extend serviceability and avert expensive repairs.',
        },
      ],
      footerText: '',
    },
  ],
};

const HeatingAndAirPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary">
        <MainSection
          label="Service Details"
          title="Professional HVAC Services in San Diego"
          description="Enjoy perfect indoor temperatures with our expert HVAC services in San Diego. From installation to maintenance, we make sure your home or business stays comfortable year-round."
          withContactButton
        />
      </MainSectionLayout>

      <Section variant="secondary">
        <Container>
          <ContentLayout
            contentLeft={
              <>
                <ServicesNavMenu />
                <RequestForm />
              </>
            }
            contentRight={<ContentV2 data={data} />}
          />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ServiceCardsSection shortVariant={true} />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default HeatingAndAirPage;
